import React from 'react';

// Whether an unload call is in flight; the unload page sets it, and its scan field takes no scan while it is
export const UnloadCallPending = React.createContext(false);
